export default "__VITE_ASSET__WqDFqFSK__"